module.exports = __webpack_public_path__ + "static/media/corporate-services-img37.b123105d.jpg";